import { useMemo } from 'react';

import { Box } from '../../../../Miscellaneous/Box';
import { Text } from '../../../../Typography/Text/Text';
import { CardCardCart } from './cartCard.types';
import type { CartItem } from './types';
import { typeToDescriptionMap, useGetCartItemType } from './utils';

const CartItemDescription = ({
  cartItem,
  isRecurring = false,
  cart,
}: {
  cartItem: Partial<CartItem>;
  isRecurring?: boolean;
  cart: CardCardCart;
}) => {
  const storeItem = cartItem?.store_item;
  const getCartItemType = useGetCartItemType(cart);

  const description = useMemo(() => {
    const type = getCartItemType(cartItem as CartItem);

    return typeToDescriptionMap.get(type)?.({
      ...(cartItem as CartItem),
      isRecurring,
    });
  }, [getCartItemType, cartItem, isRecurring]);

  if (!storeItem) return null;

  return (
    <Box>
      <Text
        fz="xs"
        style={{
          wordBreak: 'break-word',
        }}
      >
        {description}
      </Text>
    </Box>
  );
};

export { CartItemDescription };
